import { render } from "./PaymentFeature.vue?vue&type=template&id=93c0c4f4&scoped=true"
import script from "./PaymentFeature.vue?vue&type=script&lang=js"
export * from "./PaymentFeature.vue?vue&type=script&lang=js"

import "./PaymentFeature.vue?vue&type=style&index=0&id=93c0c4f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93c0c4f4"]])

export default __exports__